<template>
  <div class="main frame-inside">
    <div class="frame-bg">
      <img class="frame-img" src="/assets/images/frame-inside.webp" alt />
    </div>
    <div class="frame-overlay"></div>
    <div class="frame-content container-fluid fade-in">
      <div
        class="frame-text"
        :data-aos="animation"
      >
        <h1 class="frame-heading mb-4">
          MAGNIFICENT HALL OF<br />
          ASGARD AWAITS
        </h1>
        <p class="lead">The great adventure of ValhallaVerse begins!</p>
        <p class="lead">
          Create your deck and build a strategy<br />
          with Warrior & Skill Card NFTs<br />
          that will lead you to victory!
        </p>
        <p class="lead">
          Let ‘Handbook’ guide you on your journey<br />
          to the ultimate glory.
        </p>
        <div class="read-book mt-5">
          <a @click="showModal" class="btn btn-lg btn-primary">Read Handbook</a>
        </div>
      </div>
    </div>
    <modal name="book" v-if="!$device.mobile" :width="width" :height="height">
      <div slot="top-right">
        <div class="icon" @click="$modal.hide('book')"></div>
      </div>
      <book></book>
    </modal>
  </div>
</template>

<script>
import Book from '@/components/Book.vue';

export default {
  data() {
    return {
      width: window.innerWidth,
      height: window.innerHeight - 2.5 * 16, // 2.5rem
    };
  },
  mounted() {
//
  },
  methods: {
    showModal() {
      if (this.$device.mobile) {
        window.open('https://bit.ly/3BQ1dk3', '_blank');
      } else {
        this.$modal.show('book');
      }
    },
  },
  components: {
    Book,
  },
};
</script>

<style lang="scss" scoped>
.frame-inside {
  position: relative;
  overflow: hidden;
  .frame-bg {
    position: relative;
    height: 100%;
    width: 100%;
    min-height: 100vh;
    overflow: hidden;
    .frame-img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      min-height: 100vh;
      transition: transform 1s ease-in-out;
    }
    .img-front {
      z-index: 2;
    }
  }
  .frame-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 0) 2.5%,
      rgba(0, 0, 0, 0) 97.5%,
      rgba(0, 0, 0, 1) 100%
    );
  }
  .frame-content {
    position: absolute;
    z-index: 1;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    .frame-text {
      padding-left: 3rem;
      margin-bottom: 3rem;
      text-shadow: 0 0 5px rgb(0 0 0);
      .frame-heading {
        color: #ffeec2;
        text-transform: uppercase;
      }
      p {
        margin-bottom: 2rem;
      }
    }
    @media (max-width: 767.98px) {
      justify-content: flex-start;
      .frame-text {
        padding-left: 1rem;
        margin-top: 6rem;
        p {
          margin-bottom: 0.5rem;
        }
      }
    }
  }
  .fade-out {
    opacity: 0;
    transition: opacity 0.5s linear;
  }
}
</style>
